import { render, staticRenderFns } from "./PenalidadeAbaDocumentos.vue?vue&type=template&id=6d538b7f"
import script from "./PenalidadeAbaDocumentos.vue?vue&type=script&lang=js"
export * from "./PenalidadeAbaDocumentos.vue?vue&type=script&lang=js"
import style0 from "./PenalidadeAbaDocumentos.vue?vue&type=style&index=0&id=6d538b7f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports